// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2mdg1","emails":"CreateEditClinics_emails__1Cv9M","emailTagLabel":"CreateEditClinics_emailTagLabel__3x6Tw"};